export { default as BrandInfo } from "./BrandInfo";
